export const environment = {
  production: false,
  baseUrl: '',
  wsBaseUrl: 'ws://',
  localStorageSchemaVersion: '1',
};
